import React from "react"
import { useNavigate } from "react-router-dom"

import { Button } from "primereact/button"

import ROUTES from "../../../router/routesConstants"

function NavBottom() {
  const navigate = useNavigate()
  return (
    <div className="nav-bottom">
      <div>
        <Button
          label="Canjear"
          icon="pi pi-gift"
          onClick={() => navigate(ROUTES.REDEEM_REWARDS)}
        />
      </div>
      <div>
        <Button
          label="Mis Puntos"
          icon="pi pi-sparkles"
          onClick={() => navigate(ROUTES.TRANSACTION_HISTORY)}
        />
      </div>
      <div>
        <Button
          label="Perfil"
          icon="pi pi-user-edit"
          onClick={() => navigate(ROUTES.PROFILE)}
        />
      </div>

      <div>
        <Button
          label="Contacto"
          icon="pi pi-envelope"
          onClick={() => navigate(ROUTES.CONTACT_US)}
        />
      </div>
    </div>
  )
}

export default NavBottom
